// Geteilte Formatierungs-Helper.

/**
 * Wandelt eine beliebig formatierte Telefonnummer in einen tel:-href um.
 * Behält das führende '+', alles andere wird auf Ziffern reduziert, sodass
 * Softphones / iPhone / FaceTime / Skype etc. die Nummer korrekt verstehen.
 */
export function formatTelefonHref(phone) {
  if (!phone) return null;
  const cleaned = String(phone).replace(/[^\d+]/g, '');
  if (!cleaned) return null;
  return `tel:${cleaned}`;
}

/** Formatiert einen Geldbetrag als deutsche €-Anzeige (z. B. "150.000 €"). */
const GELD_FORMATTER = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});

export function formatGeld(value) {
  if (value == null || value === '' || Number.isNaN(Number(value))) return '';
  return GELD_FORMATTER.format(Number(value));
}

/** Liefert eine menschenlesbare Dateigröße (B / KB / MB / GB). */
export function formatDateigroesse(bytes) {
  if (bytes == null || Number.isNaN(Number(bytes))) return '';
  const n = Number(bytes);
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

/**
 * Reduziert eine beliebig formatierte Telefonnummer auf reine Ziffern.
 * "+49 (30) 1234-567" → "49301234567". Liefert "" bei null/undefined/leer.
 * Wird für tolerante Telefonnummer-Suche genutzt: beide Seiten (Eingabe und
 * Datenbankwert) werden normalisiert und dann mit includes verglichen.
 */
export function normalizePhone(value) {
  if (value == null) return '';
  return String(value).replace(/\D/g, '');
}

/**
 * Erkennt, ob eine Sucheingabe als Telefonnummer zu interpretieren ist:
 * keine Buchstaben + mindestens zwei Ziffern. Dann lohnt sich der reine
 * Ziffernvergleich gegen Telefonfelder; sonst läuft die normale Textsuche.
 */
export function isPhoneQuery(value) {
  if (!value) return false;
  const trimmed = String(value).trim();
  if (!trimmed) return false;
  if (/[a-zA-ZäöüÄÖÜß]/.test(trimmed)) return false;
  return (trimmed.match(/\d/g) || []).length >= 2;
}

/**
 * Macht aus einer beliebigen Website-Eingabe ein href, das im Browser öffnet.
 * Ergänzt fehlendes Protokoll mit "https://"; existierendes http(s):// bleibt.
 * Gibt null zurück, wenn der Input leer/nur Whitespace ist.
 */
export function formatWebsiteHref(url) {
  if (!url) return null;
  const trimmed = String(url).trim();
  if (!trimmed) return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

/** Extrahiert die Dateiendung in Großbuchstaben (z. B. 'PDF', 'DOCX'). */
export function dateiendung(filename) {
  if (!filename) return '';
  const idx = filename.lastIndexOf('.');
  if (idx <= 0 || idx === filename.length - 1) return '';
  return filename.slice(idx + 1).toUpperCase();
}
